module.exports = __webpack_public_path__ + "img/blue_oysters.b28b9ec7.webp";